import { render, staticRenderFns } from "./BusDataSyncDataSourceList.vue?vue&type=template&id=2bf53961&scoped=true&"
import script from "./BusDataSyncDataSourceList.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncDataSourceList.vue?vue&type=script&lang=js&"
import style0 from "./BusDataSyncDataSourceList.vue?vue&type=style&index=0&id=2bf53961&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf53961",
  null
  
)

export default component.exports